import { useNavigate } from "react-router-dom";
import Faq from "../../FAQ/faq";

const SolarEPCServices = () => {

  const navigate = useNavigate();
  const handleClick = () => {
    navigate("/contact");
  };

  return (
    <>
      <div
        className="w-full flex justify-center items-center text-white font-bold px-4 bg-cover bg-center min-h-[220px] md:min-h-[280px] py-10 md:py-16"
        style={{
          backgroundImage: `url(/banner.png)`,
        }}
      >
        <div className="text-center  max-w-[95%] sm:max-w-[80%] md:max-w-[60%] px-2">
          <h1 className="text-brand-green text-2xl sm:text-3xl md:text-7xl leading-snug sm:leading-normal">
            Comprehensive End-to-End Solar Solutions
          </h1>
          <p className="text-sm sm:text-base md:text-lg mt-4 text-black leading-relaxed">
            At Kyra Green Energy Solution, we offer complete Solar EPC services designed to make your solar projects seamless, cost-effective, and long-lasting. From initial design and planning to procurement, installation, and maintenance, our team ensures every step of the process is handled with care and expertise, ensuring you get the best results at the most competitive prices.          </p>
        </div>
      </div>

      <div className="bg-gray-50">
        <section className="py-16 px-4 bg-white">
          <div className="max-w-6xl mx-auto">
            <div className="grid md:grid-cols-2 gap-12 items-center">
              <div>
                <h2 className="text-3xl md:text-4xl font-bold mb-6 text-brand-green">
                  Solar System Design
                </h2>
                <p className="text-gray-700 mb-6 leading-relaxed">
                  We Begin Every Project With Customized Design Solutions,
                  Tailored To Your Energy Needs, Budget, And Space. Our Team Uses
                  The Latest Tools And Software To Design Efficient,
                  High-Performance Systems That Maximize Your Return On
                  Investment.
                </p>
                <div className="space-y-3">
                  <h3 className="font-semibold">
                    Key Services:
                  </h3>
                  <ul className="space-y-2 text-gray-700">
                    <li className="flex items-start">
                      <span className="mr-2 ">•</span>
                      Site Assessment And Analysis
                    </li>
                    <li className="flex items-start">
                      <span className="mr-2 ">•</span>
                      Customized System Design (On-Grid, Hybrid, Off-Grid)
                    </li>
                    <li className="flex items-start">
                      <span className="mr-2 ">•</span>
                      Energy Load And Production Forecasts
                    </li>
                  </ul>
                </div>
              </div>
              <div className="">
                <img
                  src="/Panel-Wiring-Setup.png"
                  alt="Solar System Design"
                />
              </div>
            </div>
          </div>
        </section>

        <section className="py-16 px-4 bg-gray-50">
          <div className="max-w-6xl mx-auto">
            <div className="grid md:grid-cols-2 gap-12">
              <div>
                <h2 className="text-3xl md:text-4xl font-bold mb-6 text-brand-green">
                  Procurement Of Solar Components
                </h2>
                <p className="text-gray-700 mb-6 leading-relaxed">
                  We Manage The Procurement Of All Solar System Components,
                  Ensuring You Get High-Quality, Reliable Products At The Best
                  Prices. As Distributors For Leading Solar Brands, Like Luminous,
                  Microtek, And Others, We Source Only Premium Panels, Inverters,
                  And Storage Systems Are Used In Your System.
                </p>
                <div className="space-y-3">
                  <h3 className="font-semibold ">
                    Key Services:
                  </h3>
                  <ul className="space-y-2 text-gray-700">
                    <li className="flex items-start">
                      <span className="mr-2 ">•</span>
                      Solar Panels (Mono, Poly, 72kW High-Efficiency)
                    </li>
                    <li className="flex items-start">
                      <span className="mr-2 ">•</span>
                      Inverters (On-Grid, Hybrid, Off-Grid)
                    </li>
                    <li className="flex items-start">
                      <span className="mr-2 ">•</span>
                      Energy Storage Systems (Lithium And Lead-Acid)
                    </li>
                  </ul>
                </div>
              </div>

              <div>
                <h2 className="text-3xl md:text-4xl font-bold mb-6 text-brand-green">
                  Installation And Commissioning
                </h2>
                <p className="text-gray-700 mb-6 leading-relaxed">
                  Once The Design And Procurement Are Completed, We Take Care Of
                  The Installation Of Your System, Ensuring The Highest Standards
                  Of Quality And Safety. Our Experienced Engineers, Oversee Every
                  Installation To Ensure It Operates Safely And Efficiently.
                </p>
                <div className="space-y-3">
                  <h3 className="font-semibold">
                    Key Services:
                  </h3>
                  <ul className="space-y-2 text-gray-700">
                    <li className="flex items-start">
                      <span className="mr-2 ">•</span>
                      Professional Installation Team
                    </li>
                    <li className="flex items-start">
                      <span className="mr-2 ">•</span>
                      Compliance With All Local And International Standards
                    </li>
                    <li className="flex items-start">
                      <span className="mr-2 ">•</span>
                      Fast And Efficient Project Delivery
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Monitoring & Maintenance */}
        <section className="py-16 px-4 bg-white">
          <div className="max-w-6xl mx-auto">
            <div className="grid md:grid-cols-2 gap-12 items-center">
              <div className="">
                <img
                  src="/Solar-Engineer-Inspection.png"
                  alt="Solar Maintenance"
                // className="rounded-lg object-cover w-full h-full"
                />
              </div>
              <div>
                <h2 className="text-3xl md:text-4xl font-bold mb-6 text-brand-green">
                  System Monitoring & Maintenance
                </h2>
                <p className="text-gray-700 mb-6 leading-relaxed">
                  Our Services Don't End With Installation. We Offer Continuous
                  Monitoring, Maintenance, And Support Services To Ensure Your
                  Solar System Maintains Peak Performance Throughout Its Life
                  Cycle. Whether It's A Residential Rooftop Or A Large Industrial
                  System, We Provide Comprehensive Maintenance Services To Keep
                  Everything Running Smoothly.
                </p>
                <div className="space-y-3">
                  <h3 className="font-semibold ">
                    Key Services:
                  </h3>
                  <ul className="space-y-2 text-gray-700">
                    <li className="flex items-start">
                      <span className="mr-2 ">•</span>
                      Real-Time Monitoring (Via Mobile App Or Web Portal)
                    </li>
                    <li className="flex items-start">
                      <span className="mr-2 ">•</span>
                      Preventive Maintenance And Cleaning
                    </li>
                    <li className="flex items-start">
                      <span className="mr-2 ">•</span>
                      Troubleshooting And Repairs
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Why Choose */}
        <section className="py-16 px-4 bg-gray-50">
          <div className="max-w-6xl mx-auto">
            <div className="grid md:grid-cols-2 gap-12 items-start">
              <div>
                <h2 className="text-3xl md:text-4xl font-bold mb-8 text-brand-green">
                  Why Choose Kyra Green Energy For Your Solar EPC Projects?
                </h2>
                <ul className="space-y-4 text-gray-700">
                  {[
                    "End-To-End Services: From Design To Installation And Maintenance, We Handle Every Part Of Your Solar Project.",
                    "Expert Team: Our Engineers And Installers Are Trained To Handle Projects Of Any Size And Complexity.",
                    "Custom Solutions: We Provide Tailored Solar Solutions That Fit Your Specific Needs, Whether Residential, Commercial, Or Industrial.",
                    "Quality Assurance: As Trusted Distributors Of Polycrystal, Monocrystal And Adani Solar, We Ensure The Use Of High-Quality Components In Every Installation.",
                    "Competitive Pricing: We Offer Cost-Effective Solutions Without Compromising On Quality, Providing Value For Your Investment.",
                    "Long-Term Support: Our Team Offers Warranty-Backed Services And Maintenance Plans To Ensure The Longevity And Efficiency Of Your Solar System.",
                  ].map((text, i) => (
                    <li key={i} className="flex items-start">
                      <span className="mr-3 mt-1">•</span>
                      <span>{text}</span>
                    </li>
                  ))}
                </ul>
                <button
                  className="mt-8 text-white px-8 py-3 rounded-lg font-semibold hover:opacity-90 bg-brand-green transition-colors"
                  onClick={handleClick}
                >
                  Explore Our Solar EPC Services
                </button>
              </div>
              <div className="">
                <img
                  src="/Standalone-Panel-Model.png"
                  alt="Solar Installation"
                // className="rounded-lg object-contain w-full h-full"
                />
              </div>
            </div>
          </div>
        </section>

        {/* Dealer & Distributor */}
        <section className="py-16 px-4 bg-white">
          <div className="max-w-6xl mx-auto">
            <div className="grid md:grid-cols-2 gap-12 items-center">
              <div>
                <h2 className="text-3xl md:text-4xl font-bold mb-6 text-brand-green">
                  Dealer & Distributor Pricing For EPC Projects
                </h2>
                <p className="text-gray-700 mb-6 leading-relaxed">
                  For Dealers And Distributors, We Provide Special Pricing For
                  Bulk Purchases Of Solar Equipment For Large-Scale Projects. We
                  Also Offer EPC Packages That Include Design, Procurement, And
                  Installation Services.
                </p>
                <div className="space-y-3 mb-6">
                  <h3 className="font-semibold">
                    Pricing Includes:
                  </h3>
                  <ul className="space-y-2 text-gray-700">
                    {[
                      "Solar Panels (Mono, Poly, 72kW High-Efficiency)",
                      "Inverters (On-Grid, Hybrid, Off-Grid)",
                      "Energy Storage Systems (Lithium And Lead-Acid)",
                      "Complete Installation And Commissioning Services",
                    ].map((item, i) => (
                      <li key={i} className="flex items-start">
                        <span className="mr-2">•</span>
                        {item}
                      </li>
                    ))}
                  </ul>
                </div>
                <button
                  className="text-white px-8 py-3 rounded-lg font-semibold hover:opacity-90 bg-brand-green transition-colors"
                  onClick={handleClick}
                >
                  Get Started Today
                </button>
              </div>
              <div className="">
                <img
                  src="/Solar-Farm-Installation.png"
                  alt="Solar Farm"
                // className="rounded-lg object-cover w-full h-full"
                />
              </div>
            </div>
          </div>
        </section>
        <Faq type="epc" />
      </div>
    </>
  );
};

export default SolarEPCServices;
